import React, { useEffect, useState, useRef } from 'react';
import BreadCrumbComponent from '../bread-crumb/BreadCrumbComponent';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../AppInsights';
import { withMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Spinner from "../Spinner"
import { Toast } from 'primereact/toast';
import { MessageSeverity, FilterMatchMode, FilterOperator } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { RabbitMqService } from './RabbitMqService';
import { AdminService } from '../admin/AdminService';
import './RabbitMq.css'

function RabbitMqAuthUserComponent(props) {
    const alertMessage = useRef(null);
    const rabbitMqService = new RabbitMqService();
    const adminService = new AdminService();

    const [pageErrorMessage, setpageErrorMessage] = useState(null)
    const [pageSuccessMessage, setpageSuccessMessage] = useState(null)
    const [hideSpinner, sethideSpinner] = useState(false);
    const [rabbitMqAuthUsers, setRabbitMqAuthUsers] = useState([]);
    const [filters, setfilters] = useState({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [showAddUserDialog, setShowAddUserDialog] = useState(false);
    const [selectedUserRow, setSelectedUserRow] = useState('');
    const [addUserName, setAddUserName] = useState('');
    const [adminRoles, setAdminRoles] = useState([]);

    const getAdminRoles = () => {
        adminService.getAdminRoles(props.msalContext).then(
            (d) => {
                setAdminRoles(d);
                setpageErrorMessage(null);
            }
        ).catch(e => {
            console.log(e)
        });
    }

    const getRoleId = () => {
        if (adminRoles && adminRoles.length > 0) {
            switch (true) {
                case adminRoles.includes('SuperAdmin'):
                case adminRoles.includes('Admin'):
                    return 1;
                default:
                    return 0;
            }
        }
        return 0;
    }

    const loadRabbitMqAuthUsers = () => {
        rabbitMqService.loadRabbitMqAuthUsers(props.msalContext).then(response => {
            if (response && response.status === 200) {
                setRabbitMqAuthUsers(response.body)
                sethideSpinner(true)
            }
            else {
                sethideSpinner(true)
                setpageErrorMessage("Something went wrong !!!")
            }
        }).catch(e => {
            console.log(e)
            setpageErrorMessage("Something went wrong !!!")
        })
    }

    useEffect(() => {
        loadRabbitMqAuthUsers()
        getAdminRoles() //HDO-8090 - to get the user role and show/hide action column accordingly
    }, [])

    const validateUsername = async () => {
        sethideSpinner(false); setpageErrorMessage(null); setpageSuccessMessage(null);
        var addUserNameText = /^[^'"@!#$%^&*?]*$/.test(addUserName);
        if (!addUserNameText) {
            setpageErrorMessage("Username should not contain special characters (',\",@,!,#,$,%,^,&,*,?)");
            sethideSpinner(true);
            return;
        }
        else {
            isUserExists()
        }
    }

    const isUserExists = () => {
        setpageErrorMessage(null); setpageSuccessMessage(null);
        if (addUserName === null || addUserName === undefined | addUserName === "") {
            setpageErrorMessage("Username is required"); sethideSpinner(true);
            return;
        }
        rabbitMqService.isRabbitMqAuthUserExists(addUserName, props.msalContext).then(response => {
            if (response.status === 403) {
                sethideSpinner(true);
                setpageErrorMessage("You do not have permission to perform this operation.")
            } else if (response.status === 200 && response.body) {
                sethideSpinner(true);
                setpageErrorMessage("User name already exists.")
            } else {
                addUser()
            }
        }).catch(e => {
            console.log(e)
            setpageErrorMessage("Something went wrong !!!"); sethideSpinner(true);
        })
    }

    const addUser = () => {
        sethideSpinner(false);
        rabbitMqService.addRabbitMqAuthUser(addUserName, props.msalContext).then(response => {
            if (response && response.status === 200) {
                setRabbitMqAuthUsers(response.body)
                sethideSpinner(true)
                setpageSuccessMessage("User added successfully")
                setAddUserName("")
                setShowAddUserDialog(false)
            }
            else {
                sethideSpinner(true)
                setAddUserName("")
                setpageErrorMessage("Something went wrong !!!")
            }
        }).catch(e => {
            console.log(e)
            setpageErrorMessage("Something went wrong !!!"); sethideSpinner(true);
        })
    }

    const deleteUser = () => {
        console.log(selectedUserRow)
        setpageErrorMessage(null); setpageSuccessMessage(null);
        setShowDeleteConfirm(false); sethideSpinner(false);
        rabbitMqService.deleteRabbitMqAuthUser(selectedUserRow.Id, selectedUserRow.Name, props.msalContext).then(response => {
            if (response && response.status === 200) {
                setRabbitMqAuthUsers(response.body)
                sethideSpinner(true)
                setpageSuccessMessage("User deleted successfully")
            }
            else {
                sethideSpinner(true)
                setpageErrorMessage("Something went wrong !!!")
            }
        }).catch(e => {
            console.log(e)
            setpageErrorMessage("Something went wrong !!!"); sethideSpinner(true);
        })
    }

    const onGlobalFilterChange = (event) => {
        setpageErrorMessage(null); setpageSuccessMessage(null);
        const value = event.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setfilters(_filters);
        setGlobalFilterValue(value);
    }

    const globalSearchFilter = () => {
        return (
            <div>
                <div className="flex justify-content-between" >
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearDataTableFilters} />
                    <h4>RABBIT MQ AUTH USERS</h4>
                    <span className="p-input-icon-left">
                        <i className="pi pi-search"></i>
                        <InputText type="search" value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Global Search" size={25} />
                        {getRoleId() === 1 ? <Button label='' icon='pi pi-plus' tooltip='Add User' tooltipOptions={{ position: 'left' }} onClick={(e) => setShowAddUserDialog(true)} />
                            : <></>}
                    </span>
                </div>
            </div>
        )
    }

    const onHandleInputChange = (event) => {
        setpageErrorMessage(null); setpageSuccessMessage(null);
        setAddUserName(event.target.value)
    }

    const clearDataTableFilters = () => {
        setpageErrorMessage(null); setpageSuccessMessage(null); setGlobalFilterValue('');
        setfilters({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        })
    }

    const showActionBtns = (rowData) => {
        setpageErrorMessage(null); setpageSuccessMessage(null);
        return (
            <React.Fragment>
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" tooltip="Delete" tooltipOptions={{ position: 'top' }} onClick={(e) => { setShowDeleteConfirm(true); setSelectedUserRow(rowData) }} />
            </React.Fragment>
        )
    }

    const confirmAddFooter = (
        <div>
            <Button label='Ok' onClick={() => validateUsername()} />
            <Button label='Cancel' onClick={(e) => { setShowAddUserDialog(false) }} className='p-button-secondary' />
        </div>
    );

    const confirmDeleteFooter = (
        <div>
            <Button label='Ok' onClick={() => deleteUser()} />
            <Button label='Cancel' onClick={(e) => { setShowDeleteConfirm(false) }} className='p-button-secondary' />
        </div>
    );

    const showError = (severity, summary, msg) => {
        alertMessage.current.show({ severity: severity, summary: summary, detail: msg, life: global.ALERT_MSG_LIFE });
    }

    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
            <div>
                <BreadCrumbComponent {...props} />
                <Toast ref={alertMessage} />
                {pageErrorMessage ? showError(MessageSeverity.ERROR, 'Error Message', pageErrorMessage) : <></>}
                {pageSuccessMessage ? showError(MessageSeverity.SUCCESS, 'Success Message', pageSuccessMessage) : <></>}

                <div hidden={hideSpinner}>
                    <Spinner />
                </div>

                <div>
                    <DataTable value={rabbitMqAuthUsers}
                        dataKey="Id"
                        selectionMode="single"
                        responsiveLayout="scroll"
                        responsive={true}
                        filters={filters}
                        header={(e) => globalSearchFilter('filters')}
                        paginator={true}
                        rows={10}
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        emptyMessage="No Records found."
                        showGridlines={true}
                        stateStorage="session" stateKey="dt-rabbitmqauthuser-session"
                    >
                        <Column field="Name" header="Auth User" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} />
                        <Column field="CreatedDateDisplay" header="Created Date" alignHeader='center' sortField='CreatedDate' sortable style={{ textAlign: 'center', width: '160px' }} />
                        <Column field="CreatedBy" header="Created By" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} />
                        <Column hidden={getRoleId() === 0 ? true : false} field="edit" header="Action" alignHeader='center' body={showActionBtns} style={{ whiteSpace: 'nowrap', width: '160px', textAlign: 'center' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog header='Add User'
                footer={confirmAddFooter}
                visible={showAddUserDialog} width='400px' modal={true}
                onHide={(e) => { setShowAddUserDialog(false) }} maximizable={false}>
                <div>
                    <table>
                        <tr>
                            <td>
                                <label className='required-field'><b>Username</b></label>
                                <InputText type='text' name='Username' value={addUserName || ''} onChange={onHandleInputChange} />
                            </td>
                        </tr>
                    </table>
                </div>
            </Dialog>

            <Dialog header='Delete User'
                footer={confirmDeleteFooter}
                visible={showDeleteConfirm} width='400px' modal={true}
                onHide={(e) => { setShowDeleteConfirm(false) }} maximizable={false}>
                <div>
                    Are you sure you want to delete the user <b>{selectedUserRow.Name}</b>?
                </div>
            </Dialog>
        </MsalAuthenticationTemplate>
    )
}

const WrappedRabbitMqAuthUserComponent = withMsal(RabbitMqAuthUserComponent);
export default withAITracking(reactPlugin, WrappedRabbitMqAuthUserComponent);